import { createTheme } from '@mui/material/styles';

import { createDarkThemePalette } from './dark/createPalette';

export const { palette } = createTheme({
  palette: createDarkThemePalette(),
});
